export const hotTopics = [
  {
    id: 'hot-001',
    title: '顶流男星隐婚生子实锤曝光',
    hotValue: 12850,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20night%20photography%20outside%20luxury%20hotel%20entrance%20with%20flash%20lights%2C%20celebrity%20atmosphere%2C%20dark%20moody%20cinematic%20tone%2C%20warm%20amber%20street%20lights%20against%20cool%20night%20sky%2C%20square%20crop%20editorial%20photography&width=400&height=400&seq=hot-001&orientation=squarish',
    tag: '爆',
  },
  {
    id: 'hot-002',
    title: '千万粉丝网红直播带货翻车',
    hotValue: 9870,
    image: 'https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20glass%20jar%20with%20clear%20syrupy%20liquid%20on%20laboratory%20table%2C%20scientific%20testing%20equipment%20in%20background%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20tones%2C%20square%20crop%20editorial%20style%20photography&width=400&height=400&seq=hot-002&orientation=squarish',
    tag: '热',
  },
  {
    id: 'hot-003',
    title: '上市公司高管出轨女下属',
    hotValue: 15230,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20flat%20lay%20photography%20of%20scattered%20documents%20letters%20and%20printed%20chat%20screenshots%20on%20dark%20wooden%20desk%2C%20moody%20cinematic%20lighting%2C%20warm%20amber%20tones%2C%20square%20crop%20investigative%20journalism%20atmosphere%20editorial%20style&width=400&height=400&seq=hot-003&orientation=squarish',
    tag: '爆',
  },
  {
    id: 'hot-004',
    title: '选秀节目内幕曝光排名内定',
    hotValue: 11250,
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20dark%20tv%20studio%20control%20room%20with%20multiple%20monitors%20showing%20vote%20numbers%20and%20stage%20performance%2C%20dramatic%20red%20and%20blue%20monitor%20glow%20lighting%2C%20moody%20cinematic%20atmosphere%2C%20square%20crop%20editorial%20photography&width=400&height=400&seq=hot-004&orientation=squarish',
    tag: '沸',
  },
  {
    id: 'hot-005',
    title: '富二代网红撞人逃逸被扒黑历史',
    hotValue: 13680,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20luxury%20sports%20car%20accident%20on%20city%20street%20with%20police%20lights%20flashing%2C%20rain%20wet%20asphalt%20reflecting%20red%20and%20blue%20lights%2C%20cinematic%20film%20noir%20atmosphere%2C%20square%20crop%20editorial%20photography%20style&width=400&height=400&seq=hot-005&orientation=squarish',
    tag: '爆',
  },
  {
    id: 'hot-006',
    title: '高校教授骚扰多名女学生',
    hotValue: 14200,
    image: 'https://readdy.ai/api/search-image?query=University%20campus%20building%20exterior%20at%20golden%20hour%20with%20dramatic%20long%20shadows%2C%20warm%20autumn%20light%2C%20academic%20atmosphere%2C%20square%20crop%20editorial%20photography%20style%20neutral%20warm%20tones&width=400&height=400&seq=hot-006&orientation=squarish',
    tag: '爆',
  },
  {
    id: 'hot-007',
    title: '当红小花与导演深夜同归公寓',
    hotValue: 7890,
    image: 'https://readdy.ai/api/search-image?query=Night%20street%20photography%20of%20luxury%20apartment%20building%20entrance%20with%20warm%20lobby%20lights%20glowing%2C%20dramatic%20shadows%2C%20paparazzi%20style%20atmosphere%2C%20dark%20moody%20cinematic%20tone%2C%20square%20crop%20urban%20night%20scene%20editorial%20photography&width=400&height=400&seq=hot-007&orientation=squarish',
    tag: '热',
  },
  {
    id: 'hot-008',
    title: '美妆博主遭品牌方集体封杀',
    hotValue: 6230,
    image: 'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20broken%20cosmetics%20contract%20documents%20scattered%20with%20makeup%20products%20and%20lipsticks%20on%20marble%20surface%2C%20warm%20neutral%20tones%2C%20square%20crop%20editorial%20beauty%20photography%20style%20clean%20minimalist%20aesthetic&width=400&height=400&seq=hot-008&orientation=squarish',
    tag: '新',
  },
];